import { currencies } from 'constants/currencies';

// returns the symbol for a currency name, e.g. GBP => £
const getCurrencySymbol = (currencyName = '') =>
  currencies.find((currencyTypes) => currencyTypes.name === currencyName)
    ?.symbol;

export default getCurrencySymbol;
